import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

import { GetGatewayOperationStatusResponse } from "@src/types/gateway-onboarding";

export const getGatewayOperationStatus = async (
  namespace: string,
  operationId: string,
  signal?: AbortSignal,
) => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GetGatewayOperationStatusResponse>(
      `${url}/api/v4/ns/${namespace}/operations/${operationId}`,
      { headers, signal },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      if (signal?.aborted || err.code === "ERR_CANCELED") {
        throw err;
      }

      console.error("Axios error:", err);
      throw err;
    }

    throw new Error(
      "An unexpected error occurred while checking gateway operation status.",
    );
  }
};
